import { Seo } from "@/components/seo/Seo";
import { appModeAtom } from "@/state/app.state";
import { t } from "@lingui/core/macro";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function DemoLayout() {
  const setMode = useSetAtom(appModeAtom);

  useEffect(() => {
    setMode("demo");
    return () => setMode("authed");
  }, [setMode]);

  return (
    <>
      <Seo
        title={t`Stratistics Demo`}
        description={t`Explore a demo of Stratistics with sample Strava activity data.`}
        canonicalPath="/demo/"
      />
      <Outlet />
    </>
  );
}
